import React from 'react';
import formatTime from './../../utils/formatTime';

import Icon from './../Icon';

import { STATUS_OPEN, STATUS_PROGRESS, STATUS_COMPLETE } from './../../store/orders/actions';

const OrderOpenActions = props => {
    const { order, setAccepted, setCompleted, status, btnCompleteDisabled, isStatusLoading, isFetchingStatus } = props;

    const isCompleteDisabled = btnCompleteDisabled || isStatusLoading || isFetchingStatus;

    if (status === STATUS_OPEN) {
        return (
            <div className="order-tab-actions">
                <div className="ta-right mt20">
                    <button className="btn btn-bright btn-lg" type="button" onClick={setAccepted}>
                        Accept for grading
                    </button>
                </div>
            </div>
        );
    }

    if (status === STATUS_PROGRESS) {
        return (
            <div className="order-tab-actions">
                <div className="row space-between vertical">
                    <div className="col-1 order-tab-actions-info">
                        <Icon className="svg-icon success" iconName="clock" />
                        <span className="text-success">Grading in progress</span>
                        <b>{formatTime(order.pregrader_created_at, 'hms_tn')}</b>
                    </div>
                    <div className="col-1 ta-right">
                        <button className="btn btn-bg-error btn-lg" type="button" disabled={isCompleteDisabled} onClick={setCompleted}>
                            Complete grading
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    if (status === STATUS_COMPLETE) {
        return (
            <div className="order-tab-actions">
                <div className="ta-right mt20">
                    <div className="btn btn-completed btn-lg" type="button">Graded</div>
                </div>
            </div>
        );
    }

    // if (wStatus === 'writer_completed') {
    //     return (
    //         <div className="order-tab-actions">
    //             <div className="ta-right mt20">
    //                 <span className="btn btn-completed btn-md">Completed</span>
    //             </div>
    //         </div>
    //     );
    // }

    // if (wStatus === 'writer_accept') {
    //     return (
    //         <div className="order-tab-actions">
    //             <div className="row space-between vertical">
    //                 <div className="col-1">
    //                     {!!order.writer_accept_at &&
    //                         <div className="order-tab-actions-info">
    //                             <span className="text-success">Order accepted:</span> {formatTime(order.writer_accept_at, 'dt')}
    //                         </div>
    //                     }
    //                 </div>
    //                 <div className="ta-right col-1">
    //                     <span className="btn btn-accepted btn-md">Accepted</span>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }

    // if (order.reserved) {
    //     if (order.isReservationOver) {
    //         return (
    //             <div className="order-tab-actions">
    //                 <Icon className="svg-icon warning" iconName="clock" />
    //                 <span className="text-warning">Reservation time is over.</span> <a onClick={setRejected}>Got it.</a>
    //             </div>
    //         );
    //     }
    //     if (order.reserved_by_me) {
    //         return (
    //             <div className="order-tab-actions">
    //                 <div className="row space-between vertical">
    //                     <div className="col-1 order-tab-actions-info">
    //                         <Icon className="svg-icon success" iconName="clock" />
    //                         <span className="text-success">Reserved time left</span>
    //                         <ReservedCounter time={order.reserve_deadline} onOver={setReservationOwer} />
    //                     </div>
    //                     <div className="col-1 ta-right">
    //                         <button className="btn btn-error btn-sm" type="button" disabled={isStatusLoading} onClick={setRejected}>Reject</button>
    //                         <button className="btn btn-ok btn-md" type="button" disabled={isStatusLoading} onClick={setAccepted}>Accept</button>
    //                     </div>
    //                 </div>
    //             </div>
    //         );
    //     }
    //     return (
    //         <div className="order-tab-actions">
    //             <div className="order-tab-actions-info">
    //                 <Icon className="svg-icon error" iconName="clock" />
    //                 <span className="text-danger">This order reserved by another user</span>
    //             </div>
    //         </div>
    //     );
    // }

    // if (order.writer_status === 'client_paid') {
    //     return (
    //         <div className="order-tab-actions row vertical space-between">
    //             <div className="col-4">
    //                 {!order.is_recommended &&
    //                     <div>
    //                         {order.viewingCount === 1 &&
    //                             <p className="text-success">Other <span className="views-count">one writer</span> is watching this order right now</p>
    //                         }
    //                         {order.viewingCount > 1 &&
    //                             <p className="text-success">Other <span className="views-count">{order.viewingCount}</span> writers are watching this order right now</p>
    //                         }
    //                     </div>
    //                 }
    //             </div>
    //             <div className="col-4 ta-right">
    //                 <button className="btn btn-light btn-md" type="button" disabled={isStatusLoading} onClick={setReserved}>Reserve</button>
    //                 <button className="btn btn-bright btn-md" type="button" disabled={isStatusLoading} onClick={setAccepted}>Accept</button>
    //             </div>
    //         </div>
    //     );
    // }

    return null;
};

export default OrderOpenActions;



// WEBPACK FOOTER //
// ./src/components/order/OrderOpenActions.js